import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

// TODO-AUDIT: with new version, ReactDom.render is replaced by createRoot
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
